<template>
<m-pageframe
    title="RedChirp Staff Roles"
>
<v-container
    fluid
>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
        <template v-slot:item.is_archived="{ item }">
            <v-simple-checkbox
                 :value="item.is_archived" 
             />
        </template>
    
        <template v-slot:item.role_admin="{ item }">
            <v-simple-checkbox
                 :value="item.red_chirp_staff_roles.includes('administrator')" 
                 v-on:click="onClickRole(item, 'administrator')"
             />
        </template>

         <template v-slot:item.role_dev="{ item }">
            <v-simple-checkbox
                 :value="item.red_chirp_staff_roles.includes('developer')" 
                 v-on:click="onClickRole(item, 'developer')"
             />
        </template>

         <template v-slot:item.role_customer_service="{ item }">
            <v-simple-checkbox
                 :value="item.red_chirp_staff_roles.includes('customer-service')" 
                 v-on:click="onClickRole(item, 'customer-service')"
             />
        </template>

         <template v-slot:item.role_finance="{ item }">
            <v-simple-checkbox
                 :value="item.red_chirp_staff_roles.includes('finance')" 
                 v-on:click="onClickRole(item, 'finance')"
             />
        </template>

         <template v-slot:item.role_sales="{ item }">
            <v-simple-checkbox
                 :value="item.red_chirp_staff_roles.includes('sales')" 
                 v-on:click="onClickRole(item, 'sales')"
             />
        </template>
    
    </v-data-table>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {
    data() {
        return {
            full_text: null,
            
            headers: [
                { text: 'Label', value: 'employee_label' },
                { text: 'Username', value: 'username' },
                { text: 'Archived', value: 'is_archived'},

                { text: 'Administrator', value: 'role_admin' },
                { text: 'Developer', value: 'role_dev' },
                { text: 'Customer Service', value: 'role_customer_service' },
                { text: 'Finance', value: 'role_finance' },
                { text: 'Sales', value: 'role_sales' },
            ],

            results: [],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/admin/search-employees',
            
                'params' : {
                        'is_system_admin': true,
                        'employee_id': { 'type': 'not-equals', 'value': '17c749f9-f2f2-4cc0-9260-23acd7fc4d1d' },
                        'sort': 'employee_label',
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to complete API call',
            });
        },

        onClickRole(item, role)
        {
            if ( !this.$rc.$state.hasRedChirpStaffRole('administrator') )
            {
                this.$rc.alert('Insufficient Permissions to Change Roles', 'You do not have the RedChirp Staff Administrator role which is required to grant / revoke staff roles.');
                return;
            }

            let verb = item.red_chirp_staff_roles.includes(role) ? 'Revoke' : 'Grant';

            this.$rc.confirm({
                'title': verb+' Role: '+role,
                'body': 'Do you want to '+verb.toLowerCase()+' '+item.employee_label+' the RedChirp Staff Role: '+role,
                'btn_text_ok': verb,
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    
                    this.$rc.rest({
                        'spinner': true,
                        'endpoint': 'PUT: /api/v1/admin/red-chirp-staff-roles',
                    
                        'params' : {
                                'employee_id': item.employee_id,
                                'role': role,
                                'value': !item.red_chirp_staff_roles.includes(role),
                            },
                    
                        'on_success': (data) => {
                                this.doUpdate();
                            },
                    
                        'on_error': 'Unable to update staff role',
                    });

                },
            });
        },
        
    },

}
</script>

<style lang="scss" scoped>
</style>